let css = require('./statistic.css');
let leftHeader = require('./left-header');
let topHeader = require('./top-header');
let cornerHeader = require('./corner-header');
let preloader = require('../../../layout/preloader');

class Statistic {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            data.yStartIndexIsEven = data.yStartIndex % 2 === 0;
            return Object.assign({}, data, { css });
        });
    }
}

module.exports = {
    constructor: Statistic,
    children: [
        {
            name: 'left-header',
            component: leftHeader,
            watcher: {
                items: ['account', 'statistic', 'header', 'left', 'data'],
                yStartIndex: ['account', 'statistic', 'yStartIndex']
            }
        },
        {
            name: 'top-header',
            component: topHeader,
            watcher: {
                items: ['account', 'statistic', 'header', 'top', 'data']
            }
        },
        {
            name: 'corner-header',
            component: cornerHeader
        },
        {
            name: 'preloader',
            component: preloader,
            props: {
                size: 'big'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/statistic/scrollable/index.js